import { useState } from "react";
import {
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import styles from "./ChartCard.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const ChartCard = ({ dataSets }) => {
    const [activeKey, setActiveKey] = useState("impressions");

    const tabs = [
        { key: "impressions", label: "Lượt hiển thị" },
        { key: "interactions", label: "Lượt tương tác" },
        { key: "cost", label: "Chi phí QC" },
        { key: "reviews", label: "Lượt đánh giá" },
    ];

    return (
        <div className={cx("card")}>
            <ResponsiveContainer width="100%" height={350}>
                <LineChart data={dataSets[activeKey]}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" tick={{ fontSize: 12 }}
                        type="category"
                        padding={{ left: 0, right: 20 }} 
                        />
                    <YAxis tick={{ fontSize: 12 }} />
                    <Tooltip
                        contentStyle={{ fontSize: 12 }}
                        itemStyle={{ fontSize: 12 }}
                        labelStyle={{ fontSize: 12 }}
                    />
                    <Legend wrapperStyle={{ fontSize: 12 }} />
                    <Line
                        type="linear"
                        dataKey="value"
                        stroke="#2483f2"
                        strokeWidth={3}
                        dot={false}
                        name={tabs.find((t) => t.key === activeKey)?.label}
                    />
                    <Line
                        type="linear"
                        dataKey="compare"
                        stroke="#555"
                        strokeWidth={2}
                        dot={false}
                        name="So với cùng kì"
                    />
                </LineChart>
            </ResponsiveContainer>

            <div className={cx("tabs")}>
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveKey(tab.key)}
                        className={cx("tabBtn", { active: activeKey === tab.key })}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ChartCard;
